<template>
  <div class="body">
    <img class="Bgc" src="https://p0.ssl.qhimg.com/t012d38343fd75e2dd9.png" alt="背景图" />
    <div class="nav">
      <div class="navTitle">生态伙伴</div>
      <div class="navDesc">ECO-PARTNERS</div>
      <div class="partner">
        <div class="partnerList" v-for="(item, index) in ecoArr" :key="index">
          <img :src="item.header_index" alt="伙伴类型" class="partnerListImg" />
            <div class="partnerListBox">
              <div
                class="partnerListBoxItem"
                v-for="(subItem, subIndex) in item.list"
                :key="subIndex"
              >
                <img class="partnerListBoxImg" :src="subItem" alt="具体伙伴" />
              </div>
            </div>
        </div>
      </div>
      <div class="navMore" @click="getMore">查看更多<right-outlined /></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getEcologyPartner } from '@/api/2023/index.js'
import { RightOutlined } from '@ant-design/icons-vue'

const ecoArr = ref([]) //生态伙伴数据

onBeforeMount(async () => {
  await getInfo()
})

const getInfo = () => {
  getEcologyPartner()
    .then((res) => {
      ecoArr.value = res.data.data.slice(0, 4)
    })
    .catch(() => {})
}

const getMore = () => {
  const path = `${window.location.origin}/new/2023/sponsor.html`
  window.open(path)
}
</script>

<style lang="scss" scoped>
.body {
  position: relative;
  min-width: 1280px;
  height: 944px;
  .Bgc {
    width: 100%;
    height: 100%;
  }
}

.nav {
  position: absolute;
  min-width: 1280px;
  left: 50%;
  top: 100px;
  transform: translate(-50%);

  &Title {
    font-size: 40px;
    line-height: 32px;
    color: #ffffff;
    width: 160px;
    margin: 0 563px 0 557px;
  }

  &Desc {
    font-size: 28px;
    line-height: 32px;
    color: rgba(255, 255, 255, 0.6);
    width: 225px;
    text-align: center;
    margin: 18px 531px 40px 524px;
  }

  &More {
    width: 160px;
    height: 52px;
    line-height: 52px;
    background: #00ab7a;
    border-radius: 2px;
    margin: 16px auto 0;
    text-align: center;
    font-size: 20px;
    color: #ffffff;
    cursor: pointer;
  }
}

.partner {
  color: #ffffff;
  &List {
    height: 132px;
    background-color: rgba(172, 133, 54, 0.1);
    margin-top: 12px;
    display: flex;
    align-items: center;
    &Img {
      margin-left: 80px;
      width: 208px;
    }
    &Box {
      flex: 1;
      margin-left: 57px;
      height: 100px;
      display: flex;
      align-items: center;
      &Item {
        width: 172px;
        height: 80px;
        background: #ffffff;
        margin: 0 23px;
        padding: 12px 24px;
      }
      &Img {
        width: 100%;
      }
    }
  }
}
</style>
